import { Dispatch, Dispatch as ReactDispatch, SetStateAction } from "react";

export const formatValue = (value: string, useFixedPoint: boolean = false) => {
  if (useFixedPoint) {
    return Number(value)
      .toFixed(value.includes(".") ? 2 : 0)
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }

  return value.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

export const getNextValueAmount = (
  keyValue: number | string,
  value: string,
  from: string
) => {
  const valueString = keyValue.toString();
  const lastCharAtValueString = valueString.charAt(valueString.length - 1);
  const isLeadingZero = value === "" && (keyValue === 0 || keyValue === "0");
  const shouldReplaceLeadingZero = value === "0";

  let nextValue = "";
  if (isLeadingZero) {
    // Adding a dot when the user type a "leading zero" (also preventing zeros "to the left")
    nextValue = "0.";
  } else if (shouldReplaceLeadingZero) {
    // Replace "leading zero" with the value inputted to prevent zeros "to the left"
    nextValue = lastCharAtValueString;
  } else if (from === "keyboard") {
    nextValue = value + valueString;
  } else {
    nextValue = valueString;
  }

  return nextValue;
};

export const onChange = (value: string) => {
  const initWithDot = value.charAt(0) === "." ? `0.` : value;
  const formatedValue = initWithDot.replace(",", ".");
  return RegExp("^$|^[0-9]{0,7}$|^[0-9]{1,7}[.][0-9]{0,2}$").test(formatedValue)
    ? formatedValue
    : false;
};

export const onChangeValue =
  (
    setValue: ReactDispatch<SetStateAction<string>>,
    value: string,
    from: string
  ) =>
  // eslint-disable-next-line consistent-return
  (keyValue: number | string) => {
    const nextValue = getNextValueAmount(keyValue, value, from);

    const validatedValue = onChange(nextValue);

    if (validatedValue || validatedValue === "") {
      setValue(validatedValue);
    }
  };

export const submitCustomAmount = (
  value: string,
  setCustomAmount: Dispatch<SetStateAction<string>>,
  toggleCustomAmountModal: Dispatch<SetStateAction<boolean>>,
  onSelectAmount: Function
) => {
  setCustomAmount(value);
  toggleCustomAmountModal(false);
  onSelectAmount(value);
};

export const onAddPeriod =
  (value: string, setValue: ReactDispatch<SetStateAction<string>>) => () => {
    if (!value.includes(".")) {
      setValue((prevValue: string) =>
        value.charAt(0) === "" ? prevValue.concat("0.") : prevValue.concat(".")
      );
    }
  };

export const onClearValue =
  (setValue: ReactDispatch<SetStateAction<string>>) => () =>
    setValue((prevValue: string) => prevValue.slice(0, -1));
